module.exports = __webpack_public_path__ + "static/home-hero-bg-dark-0c28ee280c468130d73ddef3492206cd.png";